<template>
    <div id="contenedor-listado-programas-inversion-mobiles">
        <template
            v-for="(programaInversion, index) in listadoProgramasInversion">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ programaInversion.clave }}
                  </div>
                  <!-- <div
                    class="d-inline-block">
                    <opciones
                      :id="programaInversion.id">
                    </opciones>
                  </div> -->
                </v-card-title>
                <v-card-text>
                    {{ programaInversion.nombre }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
// import Opciones from './Opciones.vue';

export default {
  name: 'ListadoProgramasInversionMobiles',
  props: {
    listadoProgramasInversion: {
      type: Array,
      required: true,
    },
  },
  components: {
    // Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
